import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Always use light theme
  const theme = 'light';

  useEffect(() => {
    const root = window.document.documentElement;
    // Ensure dark class is removed
    root.classList.remove('dark');
    // Clear any stored theme preference
    localStorage.removeItem('theme');
  }, []);

  const toggleTheme = () => {
    // No-op: theme is always light
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);